import { Inner } from "@pagepro-monorepo/ui/lib/components/styles/Grid";
import { isValidVariant } from "@pagepro-monorepo/ui/lib/components/styles/Grid/utils";
import {
  storyblokEditable,
  StoryblokComponent
} from "@storyblok/react";

import { InnerStoryblokProps } from "./types";

const InnerStoryblok: React.FC<InnerStoryblokProps> = ({ blok }) => {
  const { innerVariant, body } = blok;

  return innerVariant &&
    isValidVariant(innerVariant) &&
    body?.length ? (
    <Inner variant={innerVariant} {...storyblokEditable(blok)}>
      {body.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </Inner>
  ) : null;
};

export default InnerStoryblok;
